// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"535":"cd55800e","962":"c27d052b"}[chunkId] + ".chunk.js";
};